import { ModalContent } from '@/components/Modal'

import { useConfigureController, useController } from '../hooks/useController'
import { Body } from './Body'
import { Footer } from './Footer'
import { Header } from './Header'

export function Content() {
  const { ready } = useConfigureController()
  const {
    data: { model },
  } = useController()

  if (!ready) return null

  const getModalWidth = () => {
    switch (model) {
      case 'export':
        return 1030
      case 'planningRange':
        return 640
      case 'delete':
        return 400
      default:
        return 640 // Default width
    }
  }

  return (
    <ModalContent header={<Header />} footer={<Footer />} minWidth={getModalWidth()}>
      <Body />
    </ModalContent>
  )
}
